import { useEffect, useRef, useState } from 'react';

interface ColorizedSvgProps {
  src: string;
  bodyColor: string;
  outlineColor: string;
  className?: string;
}

const svgCache = new Map<string, string>();

export const ColorizedSvg = ({ src, bodyColor, outlineColor, className }: ColorizedSvgProps) => {
  const [rawSvg, setRawSvg] = useState<string | null>(() => svgCache.get(src) ?? null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (svgCache.has(src)) {
      setRawSvg(svgCache.get(src)!);
      return;
    }

    let cancelled = false;
    fetch(src)
      .then((r) => r.text())
      .then((text) => {
        if (cancelled) return;
        svgCache.set(src, text);
        setRawSvg(text);
      })
      .catch((err) => {
        console.warn('[ColorizedSvg] Failed to fetch SVG:', src, err);
      });

    return () => { cancelled = true; };
  }, [src]);

  if (!rawSvg) return null;

  // Apply fill replacements:
  // - fill="white" / fill="#FFFFFF" → bodyColor
  // - fill="black" / fill="#000000" → outlineColor
  const colorized = rawSvg
    .replace(/fill="white"/gi, `fill="${bodyColor}"`)
    .replace(/fill="#FFFFFF"/gi, `fill="${bodyColor}"`)
    .replace(/fill="black"/gi, `fill="${outlineColor}"`)
    .replace(/fill="#000000"/gi, `fill="${outlineColor}"`);

  return (
    <div
      ref={containerRef}
      className={className}
      dangerouslySetInnerHTML={{ __html: colorized }}
    />
  );
};
